import BeforeAfterBreadcrumbs from "@/components/before-after-breadcrumbs/index.vue";
import CircleArrow from "@/components/@icons/CircleArrow.vue";

export default {
  name: "BeforeAfterInfo",
  components: { CircleArrow, BeforeAfterBreadcrumbs },
  props: {
    detail: {
      type: Object,
      default: null,
    },
    current: {
      type: String,
      default: null,
    },
  },
};
